<template>
    <div>
        <li class="header">NAVIGASI UTAMA</li>

              <li class="active">
                  <router-link to="/planing">
                      <i class="material-icons">home</i>
                      <span>Home</span>
                  </router-link>
              </li>
              <div v-if="cek_menu_rpjmd()" class="active">

                <li >
                    <a href="javascript:void(0);" class="menu-toggle">
                        <i class="material-icons">view_stream</i>
                        <span>RPJMD</span>
                    </a>
                    <ul class="ml-menu">
                        <li v-if="level_akses_planing.rpjmd">
                            <router-link to="/planing_rpjmd">RPJMD</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_permasalahan_pembangunan">
                            <router-link to="/planing_permasalahan_pembangunan">Permasalahan Pembangunan</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_isu_strategis">
                            <router-link to="/planing_isu_strategis">Isu Strategis</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_visi">
                            <router-link to="/planing_visi">visi</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_misi">
                            <router-link to="/planing_misi">Misi</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_tujuan">
                            <router-link to="/planing_tujuan">Tujuan</router-link>
                        </li>
                        <!-- <li v-if="level_akses_planing.rpjmd_indikator_tujuan">
                            <router-link to="/planning_indikator_tujuan_pembangunan">Indikator Tujuan Pemb.</router-link>
                        </li> -->
                        <li v-if="level_akses_planing.rpjmd_sasaran">
                            <router-link to="/planing_sasaran">Sasaran</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_strategi">
                            <router-link to="/planing_strategi">Strategi</router-link>
                        </li>

                        <li v-if="level_akses_planing.rpjmd_arah_kebijakan">
                            <router-link to="/planing_arah_kebijakan">Arah Kebijakan</router-link>
                        </li>
                        
                        <li v-if="level_akses_planing.rpjmd_arah_kebijakan_tahunan">
                            <router-link to="/planing_arah_kebijakan_tahunan">Arah Kebijakan Tahunan</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_kebijakan_umum">
                            <router-link to="/planing_kebijakan_umum">Kebijakan Umum</router-link>
                        </li>            
                        <li v-if="level_akses_planing.rpjmd_program_unggulan">
                            <router-link to="/planing_program_unggulan">Program Unggulan</router-link>
                        </li>           
                        <li v-if="level_akses_planing.rpjmd_program_pembangunan">
                            <router-link to="/planing_program_pembangunan">Program Pembangunan</router-link>
                        </li>
                        <li v-if="level_akses_planing.rpjmd_indikator_kinerja">
                            <router-link to="/planing_indikator_kinerja">Indikator Kinerja</router-link>
                        </li>
                            <!-- <li>
                                <router-link to="/planing_proyeksi_anggaran">Proyeksi Anggaran</router-link>
                            </li> -->
                                        
                            
                    </ul>
                </li>
              </div>

              <div v-if="cek_menu_renstra()">
                <li>
                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renstra')">
                        <i class="material-icons">view_day</i>
                        <span>RENSTRA SKPD</span>
                        <div class="cek_menu_renstra tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_renstra">
                        <li v-if="level_akses_planing.renstra">
                            <router-link to="/planing_renstra_renstra">Renstra SKPD</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_visi">
                            <router-link to="/planing_renstra_visi">Visi</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_misi">
                            <router-link to="/planing_renstra_misi">Misi</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_tujuan">
                            <router-link to="/planing_renstra_tujuan">Tujuan</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_sasaran">
                            <router-link to="/planing_renstra_sasaran">Sasaran</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_strategi">
                            <router-link to="/planing_renstra_strategi">Strategi</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_arah_kebijakan">
                            <router-link to="/planing_renstra_arah_kebijakan">Arah Kebijakan</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_kebijakan_umum">
                            <router-link to="/planing_renstra_kebijakan_umum">Kebijakan Umum</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_program">
                            <router-link to="/planing_renstra_program">Program</router-link>
                        </li>
                        <li v-if="level_akses_planing.renstra_kegiatan">
                            <router-link to="/planing_renstra_kegiatan">Kegiatan</router-link>
                        </li>

                        <li>

                            <a href="javascript:void(0);" @click="hover_submenu('renstra_laporan')">
                                <b>Laporan</b>
                                <div class="renstra_laporan tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <!-- <router-link to="" @click="hover_submenu('renstra_laporan')">
                                <b>Laporan</b>
                                 <i class="material-icons icon_add">add</i>
                            </router-link> -->
                            <ul class="subsubmenux" id="renstra_laporan">
                                <li>
                                    <router-link to="/planing_laporan_renstra">Visi, Misi, Tujuan dan Sasaran</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_laporan_sasaran_program">Sasaran dan Program</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_laporan_keselarasan_kinerja">Keselarasan Kinerja</router-link>
                                </li>
                                <!-- <li>
                                    <router-link to="/planing_laporan_renstra">Sasaran, Strategi dan Arah Kebikan</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_laporan_renstra">Kebijakan Umum dan Program Pembangunan</router-link>
                                </li> -->
                            </ul>
                        </li>
       
                    </ul>
                </li>

              </div>

                <template  v-if="cek_menu_rkpd()">

                    <li>
                        <a href="javascript:void(0);" @click="hover_submenu('menu_rkpd')">
                            <i class="material-icons">view_quilt</i>
                            <span>RKPD</span>
                            <div class="menu_rkpd tempat_icon"><i class="material-icons icon_add">add</i></div>
                        </a>
                        <ul class="subsubmenux"  id="menu_rkpd">
                            <li v-if="level_akses_planing.rkpd">
                                <router-link to="/planing_rkpd_awal">RKPD</router-link>
                            </li>

                            <li v-if="cek_menu_rkpd_prioritas()">

                                <a href="javascript:void(0);" @click="hover_submenu('rkpd_prioritas')">
                                    <b>Prioritas</b>
                                    <div class="rkpd_prioritas tempat_icon"><i class="material-icons icon_add">add</i></div>
                                </a>
                                <ul class="subsubmenux" id="rkpd_prioritas">
                                    <li v-if="level_akses_planing.rkpd_prioritas_nasional">
                                        <router-link to="/planing_rkpd_prioritas_nasional">Prioritas Nasional</router-link>
                                    </li>
                                    <li v-if="level_akses_planing.rkpd_prioritas_provinsi">
                                        <router-link to="/planing_rkpd_prioritas_provinsi">rioritas Provinsi</router-link>
                                    </li>
                                    <li v-if="level_akses_planing.rkpd_prioritas_daerah">
                                        <router-link to="/planing_rkpd_prioritas_daerah">Prioritas Daerah</router-link>
                                    </li>
                                </ul>
                            </li>

                            <li>
                                <a href="javascript:void(0);" @click="hover_submenu('rkpd_program_kegiatan')">
                                    <b>Program/Kegiatan</b>
                                    <div class="rkpd_program_kegiatan tempat_icon"><i class="material-icons icon_add">add</i></div>
                                </a>
                                <ul class="subsubmenux" id="rkpd_program_kegiatan">
                                    <!-- <li>
                                        <router-link to="/planing_rkpd_sasaran">Sasaran</router-link>
                                    </li> -->
                                    <li v-if="level_akses_planing.rkpd_program">
                                        <router-link to="/planing_rkpd_program">Program</router-link>
                                    </li>
                                    <li v-if="level_akses_planing.rkpd_kegiatan">
                                        <router-link to="/planing_rkpd_kegiatan">Kegiatan</router-link>
                                    </li>
                                </ul>
                            </li>

                            <!-- <li  v-if="level_akses_planing.rkpd_final"> -->
                                <!-- <a @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">RKPD Final</a> -->
                                <!-- <router-link to="/planing_rkpd_final">RKPD Final</router-link> -->
                            <!-- </li> -->
                                

                            
                        </ul>
                    </li>
                </template>




                <!-- <li v-if="cek_menu_usulan()">
                    <a href="javascript:void(0);" @click="hover_submenu('menu_usulan')">
                        <i class="material-icons">assignment</i>
                        <span>FORM USULAN</span>
                        <div class="menu_usulan tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul v-if="cek_menu_usulan()" class="subsubmenux" id="menu_usulan">
                        <li v-if="cek_menu_usulan_kecamatan()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_usulan_kecamatan')">
                                <b>Musrenbang Kecamatan</b>
                                <div class="cek_menu_usulan_kecamatan tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_usulan_kecamatan">
                                <li v-if="level_akses_planing.musren_kec">
                                    <router-link to="/planing_musrenbang_kecamatan">Form Usulan</router-link>
                                </li>
                                <li v-if="level_akses_planing.musren_kec_ver">
                                    <router-link to="/planing_ver_musrenbang_kecamatan">Form Verifikasi</router-link>
                                </li>
                                <li v-if="level_akses_planing.musren_kec_lap">
                                    <router-link to="/planing_lap_musrenbang_kecamatan">Laporan</router-link>
                                </li>
                            </ul>
                        </li>
                        <li v-if="cek_menu_usulan_pokir()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_usulan_pokir')">
                                <b>Pokok Pikiran Dewan</b>
                                <div class="cek_menu_usulan_pokir tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_usulan_pokir">
                                <li v-if="level_akses_planing.musren_pokir">
                                    <router-link to="/planing_musrenbang_pokir">Form Usulan</router-link>
                                </li>
                                <li v-if="level_akses_planing.musren_pokir_ver">
                                    <router-link to="/planing_ver_musrenbang_pokir">Form Verifikasi</router-link>
                                </li>
                                <li v-if="level_akses_planing.musren_pokir_lap">
                                    <router-link to="/planing_lap_musrenbang_pokir">Laporan</router-link>
                                </li>
                            </ul>
                        </li>
                        <li v-if="cek_menu_usulan_opd()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_usulan_opd')">
                                <b>Forum OPD</b>
                                <div class="cek_menu_usulan_opd tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_usulan_opd">
                                <li v-if="level_akses_planing.musren_opd">
                                    <router-link to="/planing_musrenbang_opd">Form Usulan</router-link>
                                </li>
                                <li v-if="level_akses_planing.musren_opd_ver">
                                    <router-link to="/planing_ver_musrenbang_OPD">Verifikasi Forum OPD</router-link>
                                </li>
                                <li v-if="level_akses_planing.musren_opd_lap">
                                    <router-link to="/planing_lap_musrenbang_OPD">Laporan</router-link>
                                </li>
                            </ul>
                        </li>
                    
                    </ul>

                </li> -->



                <li v-if="cek_menu_renja()">
                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renja')">
                        <i class="material-icons">view_module</i>
                        <span>RENJA SKPD</span>
                        <div class="cek_menu_renja tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_renja">
                        <li  v-if="level_akses_planing.renja_setup">
                            <router-link to="/planing_renja_setup">Setup Renja</router-link>
                        </li>
                        <li v-if="level_akses_planing.renja_doc">
                            <router-link to="/planing_dok_rencana_skpd">Dokumen Rencana SKPD</router-link>
                        </li>
                        <li v-if="cek_menu_renja_anggaran()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renja_anggaran')">
                                <b>Renja Anggaran</b>
                                <div class="cek_menu_renja_anggaran tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_renja_anggaran">
                                <li>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_pendapatan" @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Pendapatan</a>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_btl"  @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Belanja Tidak Langsung</a>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_penerimaan"  @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Penerimaan</a>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_pengeluaran"  @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Pengeluaran</a>
                                    <!-- <router-link v-if="level_akses_planing.renja_pendapatan" to="/planing_renja_pendapatan">Pendapatan</router-link>
                                    <router-link v-if="level_akses_planing.renja_btl" to="/planing_renja_belanja_tidak_langsung">Belanja Tidak Langsung</router-link>
                                    <router-link v-if="level_akses_planing.renja_penerimaan" to="/planing_renja_penerimaan">Penerimaan </router-link>
                                    <router-link v-if="level_akses_planing.renja_pengeluaran" to="/planing_renja_pengeluaran">Pengeluaran</router-link> -->
                                </li>
                            </ul>
                        </li>
                        <li v-if="cek_menu_renja_bl()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renja_bl')">
                                <b>Renja Belanja Langsung</b>
                                <div class="cek_menu_renja_bl tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_renja_bl">
                                <li>
                                    <router-link to="/planing_renja_program">Program</router-link>
                                    <router-link to="/planing_renja_kegiatan">Kegiatan</router-link>
                                </li>
                            </ul>
                        </li>
                        
                        <li v-if="cek_menu_renja_evaluasi_renja()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renja_evaluasi_renja')">
                                <b>Evaluasi Renja</b>
                                <div class="cek_menu_renja_evaluasi_renja tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_renja_evaluasi_renja">
                                <li>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_eval_program" @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Evaluasi Program</a>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_eval_kegiatan" @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Evaluasi Kegiatan</a>
                                    <a href="javascript:void(0);" v-if="level_akses_planing.renja_tindak_lanjut" @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">Tindak Lanjut</a>
                                    <!-- <router-link v-if="level_akses_planing.renja_eval_program" to="/planing_renja_evaluasi_program">Evaluasi Program</router-link>
                                    <router-link v-if="level_akses_planing.renja_eval_kegiatan" to="/planing_renja_evaluasi_kegiatan">Evaluasi Kegiatan</router-link>
                                    <router-link v-if="level_akses_planing.renja_tindak_lanjut" to="/planing_renja_tindak_lanjut">Tindak Lanjut</router-link> -->
                                </li>
                            </ul>
                        </li>
                        <li v-if="cek_menu_renja_laporan()">
                            <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renja_laporan')">
                                <b>Laporan</b>
                                <div class="cek_menu_renja_laporan tempat_icon"><i class="material-icons icon_add">add</i></div>
                            </a>
                            <ul class="subsubmenux" id="cek_menu_renja_laporan">
                                <li>
                                    <!-- <router-link to="/planing_renja_rekapitulasi">Rekapitulasi</router-link> -->
                                    <router-link to="/planing_renja_permendagri">Permendagri 54</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_renja_rekapitulasi">Rekapitulasi</router-link>
                                    <!-- <router-link to="/planing_renja_permendagri">Permendagri 54</router-link> -->
                                </li>
                            </ul>
                        </li>
                            
                    </ul>
                </li>

              
                <!-- <li class="header">RKA / RAPBD</li>
                <li>

                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_renja')">
                        <i class="material-icons">assignment</i>
                        <span>Setup RKA</span>
                        <div class="cek_menu_renja tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_renja">
                        <li>
                            <router-link to="/planing_ppas">Import PPAS/Renja SKPD</router-link>
                        </li>
                        <li>
                            <router-link to="/planing_hapus_rka">Hapus RKA</router-link>
                        </li>
                        <li>
                            <router-link to="/planing_sumber_anggaran">Sumber Anggaran</router-link>
                        </li>
                        <li>
                            <router-link to="/planing_tim_anggaran">Tim Anggaran</router-link>
                        </li>
                        <li>
                            <router-link to="/planing_batas_rka">Batas Waktu RKA</router-link>
                        </li>

                        <li>
                            <a href="javascript:void(0);" class="menu-toggle">Kode Rekening</a>
                            <ul class="ml-menu">
                                <li>
                                    <router-link to="/planing_kode_akun">Kode Akun</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_kode_kelompok">Kode Kelompok</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_kode_jenis">Kode Jenis</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_kode_objek">Kode Obyek</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_rincian">Kode Rincian Obyek</router-link>
                                </li>
                                <li>
                                    <router-link to="/planing_kode_barang">Kode Barang</router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li> -->


                <li class="header">DATA MASTER</li>
                <li v-if="cek_menu_data_wilayah()">
                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_data_wilayah')">
                        <i class="material-icons">room</i>
                        <span>Data Wilayah</span>
                        <div class="cek_menu_data_wilayah tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_data_wilayah">
                        <li  v-if="level_akses_planing.master_prov">
                            <router-link to="/planning_data_wilayah_provinsi">Provinsi</router-link>
                        </li>
                        <li  v-if="level_akses_planing.master_kab">
                            <router-link to="/planning_data_wilayah_kabupaten">Kabupaten</router-link>
                        </li>
                        <li  v-if="level_akses_planing.master_kec">
                            <router-link to="/planning_data_wilayah_kecamatan">Kecamatan</router-link>
                        </li>
                        <li  v-if="level_akses_planing.master_des_kel">
                            <router-link to="/planning_data_wilayah_des_kel">Desa/Kelurahan</router-link>
                        </li>
                    </ul>
                </li>
                <li v-if="cek_menu_master_urusan_satker()">
                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_master_urusan_satker')">
                        <i class="material-icons">account_balance</i>
                        <span>Urusan & Satker</span>
                        <div class="cek_menu_master_urusan_satker tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_master_urusan_satker">
                        <li  v-if="level_akses_planing.master_urusan">
                            <router-link to="/planing_urusan">Urusan</router-link>
                        </li>
                        <li  v-if="level_akses_planing.master_bidang">
                            <router-link to="/planning_bidang_urusan">Bidang</router-link>
                        </li>
                        <li v-if="level_akses_planing.master_instansi">
                            <router-link to="/planing_satker_bidang">Instansi</router-link>
                        </li>
                        <li  v-if="level_akses_planing.master_unit_kerja">
                            <router-link to="/planing_unit_kerja">Unit Kerja</router-link>
                        </li>
                    </ul>
                </li>
                <li  >
                    <a href="javascript:void(0);" @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">
                        <i class="material-icons col-green">share</i>
                        <span>Fungsi</span>
                    </a>
                    <!-- <router-link to="/planing_fungsi">
                        <i class="material-icons col-green">share</i>
                        <span>Fungsi</span>
                    </router-link> -->
                </li>
                <div  v-if="level_akses_planing.master_program">
                <li>
                    <a href="javascript:void(0);" @click="alertku('info', 'Page ini untuk sementara tidak diaktifkan oleh Administrator..!')">
                        <i class="material-icons col-green">compare</i>
                        <span>Bidang Musrembang</span>
                    </a>
                    <!-- <router-link to="/planing_bidang_musrembang">
                        <i class="material-icons col-green">compare</i>
                        <span>Bidang Musrembang</span>
                    </router-link> -->
                </li>
                </div>
                <li v-if="cek_menu_master_prog_keg()">
                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_master_prog_keg')">
                        <i class="material-icons">extension</i>
                        <span>Program Kegiatan</span>
                        <div class="cek_menu_master_prog_keg tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_master_prog_keg">
                        <li v-if="level_akses_planing.master_program">
                            <router-link to="/planing_program">Program</router-link>
                        </li>
                        <li v-if="level_akses_planing.master_kegiatan">
                            <router-link to="/planing_kegiatan">Kegiatan</router-link>
                        </li>
                    </ul>
                </li>
                <!-- <li v-if="cek_menu_master_jabatan_tupoksi()">
                    <a href="javascript:void(0);" @click="hover_submenu('cek_menu_master_jabatan_tupoksi')">
                        <i class="material-icons">contacts</i>
                        <span>Jabatan & tupoksi</span>
                        <div class="cek_menu_master_jabatan_tupoksi tempat_icon"><i class="material-icons icon_add">add</i></div>
                    </a>
                    <ul class="subsubmenux" id="cek_menu_master_jabatan_tupoksi">
                        <li  v-if="level_akses_planing.master_pegawai">
                            <router-link to="/master_biodata">Pegawai</router-link>
                        </li>
                        <li  v-if="level_akses_planing.master_jabatan">
                            <router-link to="/master_jabatan">Jabatan</router-link>
                        </li>

                    </ul>

                </li> -->

              <li  v-if="level_akses_planing.master_des_kel">
                  <a href="javascript:void(0);">
                      <i class="material-icons col-amber">settings</i>
                      <span>Pengaturan</span>
                  </a>
              </li>

    </div>
</template>

<script>
const ADD_URL_LEVEL_PLANNING = URL_APP + 'api/v1/reg_modul_planning/';
export default {
    data(){
        return{
            id_user : '',
            level_akses_planing : {
              
            }
        }
    },
    methods: {


        // ====================================== TAMBAHAN =====================================
            getLevel : function(){
                fetch(ADD_URL_LEVEL_PLANNING +'get_one',{
                    method : 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        id : 'id'
                    })
                })
                .then(res => res.json())
                .then(res_data => {
                    // console.log(res_data);
                    this.level_akses_planing = res_data;
                    // localStorage.level = JSON.stringify(res_data);
                    // console.log(this.level_akses_planing);
                });
            },
            cek_menu_rpjmd(){
                var data = this.level_akses_planing;
                // console.log('=========================');
                // console.log(data);
                if (
                    data.rpjmd == 0 &&
                    data.rpjmd_arah_kebijakan == 0 &&
                    data.rpjmd_arah_kebijakan_tahunan == 0 &&
                    data.rpjmd_indikator_kinerja == 0 &&
                    data.rpjmd_indikator_tujuan == 0 &&
                    data.rpjmd_isu_strategis == 0 &&
                    data.rpjmd_kebijakan_umum == 0 &&
                    data.rpjmd_misi == 0 &&
                    data.rpjmd_permasalahan_pembangunan == 0 &&
                    data.rpjmd_program_pembangunan == 0 &&
                    data.rpjmd_program_unggulan == 0 &&
                    data.rpjmd_sasaran == 0 &&
                    data.rpjmd_strategi == 0 &&
                    data.rpjmd_tujuan == 0 &&
                    data.rpjmd_visi == 0
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_renstra(){
                var data = this.level_akses_planing;
                if (
                    data.renstra == 0 &&
                    data.renstra_arah_kebijakan == 0 &&
                    data.renstra_kebijakan_umum == 0 &&
                    data.renstra_kegiatan == 0 &&
                    data.renstra_laporan == 0 &&
                    data.renstra_misi == 0 &&
                    data.renstra_program == 0 &&
                    data.renstra_sasaran == 0 &&
                    data.renstra_strategi == 0 &&
                    data.renstra_tujuan == 0 &&
                    data.renstra_visi == 0
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_rkpd(){
                var data = this.level_akses_planing;
                if (
                    data.rkpd == 0 &&
                    data.rkpd_final == 0 &&
                    data.rkpd_kegiatan == 0 &&
                    data.rkpd_prioritas_daerah == 0 &&
                    data.rkpd_prioritas_nasional == 0 &&
                    data.rkpd_prioritas_provinsi == 0 &&
                    data.rkpd_program == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_rkpd_prioritas(){
                var data = this.level_akses_planing;
                if (
                    data.rkpd_prioritas_daerah == 0 &&
                    data.rkpd_prioritas_nasional == 0 &&
                    data.rkpd_prioritas_provinsi == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_usulan(){
                var data = this.level_akses_planing;
                if (
                    data.musren_kec == 0 &&
                    data.musren_kec_lap == 0 &&
                    data.musren_kec_ver == 0 &&
                    data.musren_opd == 0 &&
                    data.musren_opd_lap == 0 &&
                    data.musren_opd_ver == 0 &&
                    data.musren_pokir == 0 &&
                    data.musren_pokir_lap == 0 &&
                    data.musren_pokir_ver == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_usulan_kecamatan(){
                var data = this.level_akses_planing;
                if (
                    data.musren_kec == 0 &&
                    data.musren_kec_lap == 0 &&
                    data.musren_kec_ver == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_usulan_pokir(){
                var data = this.level_akses_planing;
                if (
                    data.musren_pokir == 0 &&
                    data.musren_pokir_lap == 0 &&
                    data.musren_pokir_ver == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_usulan_opd(){
                var data = this.level_akses_planing;
                if (
                    data.musren_opd == 0 &&
                    data.musren_opd_lap == 0 &&
                    data.musren_opd_ver == 0
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_renja(){
                var data = this.level_akses_planing;
                if (
                    data.renja_btl == 0 &&
                    data.renja_doc == 0 &&
                    data.renja_eval_kegiatan == 0 &&
                    data.renja_eval_program == 0 &&
                    data.renja_lap == 0 &&
                    data.renja_pendapatan == 0 &&
                    data.renja_penerimaan == 0 &&
                    data.renja_pengeluaran == 0 &&
                    data.renja_setup == 0 &&
                    data.renja_tindak_lanjut == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_renja_anggaran(){
                var data = this.level_akses_planing;
                if (
                    data.renja_btl == 0 &&
                    data.renja_pendapatan == 0 &&
                    data.renja_penerimaan == 0 &&
                    data.renja_pengeluaran == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_renja_bl(){
                var data = this.level_akses_planing;
                if (
                    data.renja_eval_kegiatan == 0 &&
                    data.renja_eval_program == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_renja_evaluasi_renja(){
                var data = this.level_akses_planing;
                if (
                    data.renja_eval_kegiatan == 0 &&
                    data.renja_eval_program == 0 &&
                    data.renja_tindak_lanjut == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_renja_laporan(){
                var data = this.level_akses_planing;
                if (
                    data.renja_lap == 0
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_data_wilayah(){
                var data = this.level_akses_planing;
                if (
                    data.master_prov == 0 &&
                    data.master_kab == 0 &&
                    data.master_kec == 0 &&
                    data.master_des_kel == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_master_urusan_satker : function(){
                var data = this.level_akses_planing;
                if (
                    data.master_urusan == 0 &&
                    data.master_bidang == 0 &&
                    data.master_instansi == 0 &&
                    data.master_unit_kerja == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_master_prog_keg : function(){
                var data = this.level_akses_planing;
                if (
                    data.master_program == 0 &&
                    data.master_kegiatan == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            cek_menu_master_jabatan_tupoksi : function(){
                var data = this.level_akses_planing;
                if (
                    data.master_pegawai == 0 &&
                    data.master_jabatan == 0 
                    ) 
                {
                    return false;    
                } else {
                    return true;
                }
            },
            hover_submenu : function(data){

                if ($('#'+data+'').is(':visible')){
                    $('#'+data+'').hide('');
                    $('.'+data+'').empty();
                    $('.'+data+'').append('<i class="material-icons icon_add">add</i>');
                }
                else{
                    $('#'+data+'').show('');
                    $('.'+data+'').empty();
                    $('.'+data+'').append('<i class="material-icons icon_add">remove</i>');
                }

            },
            alertku : function(type, title){
                this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 1800
                });
            },

        // ====================================== TAMBAHAN =====================================
        
    },
    mounted() {

        var get_profile = JSON.parse(localStorage.profile);
        this.id_user = get_profile._id
        this.getLevel();

    },


}







</script>

<style>

</style>
